/* eslint-disable react/display-name */
import { OptionItem } from "@liebherr/patternlib/dist/types/components/form/patternlib-dropdown/patternlib-dropdown";
import Select from "components/lbc-toolkit/molecules/Select";
import React, { Key, useEffect, useState } from "react";
import { Empty, FieldItems } from "react-awesome-query-builder";

interface FieldProps {
  items?: FieldItems | undefined;
  key?: Key | null | undefined;
  placeholder?: string;
  readonly?: boolean;
  selectedKey?: string | Empty;
  selectedKeys?: string[] | Empty;
  setField?: ((path: string) => void) | undefined;
}

export default ({ key, items, setField, selectedKey, placeholder, readonly, selectedKeys }: FieldProps) => {
  const [selected, setSelected] = useState<OptionItem | undefined>();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const renderOptions = Object.values(items ?? {}).reduce<OptionItem[]>((renderOptions, current) => {
    return renderOptions.concat({ label: current?.label ?? "", value: current?.key ?? "" });
  }, []);

  useEffect(() => {
    if (!renderOptions || !selectedKey) return;
    if (!selected) setSelected(renderOptions.find((item) => item.value === selectedKey));
  }, [renderOptions, selected, selectedKey]);

  const handleSelect = (e: any) => {
    if (e.target.value === undefined) return;
    setSelected(e.target.value);
    setField?.(e.target.value);
    setIsOpen(false);
  };

  return (
    <Select
      disabled={readonly ?? false}
      placeholder={placeholder}
      selected={selectedKey ?? ""}
      id="query-builder-select"
      options={renderOptions}
      onChange={handleSelect}
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
    />
  );
};
